import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { Avatar } from "@mui/material";
import nameInitials from "name-initials";
import moment from "moment";
import { CheckPermissionRender, getIsSuperAdmin } from "../../../helpers/checkPermission";
import permissions from "../../../config/permissions";

export default function getAdminsTableData(users, onEdit, onViewPermission) {

  const isSuperAdmin = getIsSuperAdmin();

  const Author = ({ name, userName }) => {
    return (
      <MDBox display="flex" alignItems="center" lineHeight={1}>
        <Avatar size="sm">{nameInitials(name)}</Avatar>
        <MDBox ml={2} lineHeight={1}>
          <MDTypography display="block" variant="button" fontWeight="medium">
            {name}
          </MDTypography>
          <CheckPermissionRender
            permissions={permissions().rolePermission().create().update().list()}
          >
            <MDTypography variant="caption">{userName}</MDTypography>
          </CheckPermissionRender>
        </MDBox>
      </MDBox>
    );
  };

  const columns = [
    { Header: "name", accessor: "name", align: "left" },
    ...(isSuperAdmin ? [{ Header: "organization", accessor: "organization", align: "left" }] : []),
    { Header: "status", accessor: "status", align: "center" },
    { Header: "joined", accessor: "joined", align: "center" },
    { Header: "actions", accessor: "actions", align: "center" },
  ];

  return {
    columns: columns,
    rows: users.map((user) => {
      return {
        name: <Author name={user.name} userName={user.user_name} />,
        organization: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {user?.organization?.name}
          </MDTypography>
        ),
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={user.is_active ? "Active" : "Inactive"}
              color={user.is_active ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        joined: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {moment(user.createdAt).format("YY/MM/DD")}
          </MDTypography>
        ),
        actions: (
          <>
            <CheckPermissionRender permissions={permissions().systemAdmin().update().list()}>
              <MDTypography
                mr={2}
                onClick={() => {
                  onEdit(user);
                }}
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Edit
              </MDTypography>
            </CheckPermissionRender>
            <CheckPermissionRender permissions={permissions().rolePermission().read().list()}>
              <MDTypography
                onClick={() => {
                  onViewPermission(user);
                }}
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                View Permissions
              </MDTypography>
            </CheckPermissionRender>
          </>
        ),
      };
    }),
  };
}
